import React, { useState } from "react";

interface StarterTypePickerProps {
  onSelect: (types: string[]) => void;
}

const POKEMON_TYPES = [
  { name: "Normal", color: "bg-pk-normal" },
  { name: "Fire", color: "bg-pk-fire" },
  { name: "Water", color: "bg-pk-water" },
  { name: "Grass", color: "bg-pk-grass" },
  { name: "Electric", color: "bg-pk-electric" },
  { name: "Ice", color: "bg-pk-ice" },
  { name: "Fighting", color: "bg-pk-fighting" },
  { name: "Poison", color: "bg-pk-poison" },
  { name: "Ground", color: "bg-pk-ground" },
  { name: "Flying", color: "bg-pk-flying" },
  { name: "Psychic", color: "bg-pk-psychic" },
  { name: "Bug", color: "bg-pk-bug" },
  { name: "Rock", color: "bg-pk-rock" },
  { name: "Ghost", color: "bg-pk-ghost" },
  { name: "Dragon", color: "bg-pk-dragon" },
  { name: "Steel", color: "bg-pk-steel" },
  { name: "Dark", color: "bg-pk-dark" },
  { name: "Fairy", color: "bg-pk-fairy" },
];

export const StarterTypePicker: React.FC<StarterTypePickerProps> = ({
  onSelect,
}) => {
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);

  const toggleType = (typeName: string) => {
    const type = typeName.toLowerCase();
    if (selectedTypes.includes(type)) {
      setSelectedTypes(selectedTypes.filter((t) => t !== type));
    } else {
      if (selectedTypes.length < 2) {
        const newTypes = [...selectedTypes, type];
        setSelectedTypes(newTypes);
        if (newTypes.length === 2) {
          // Add a small delay for feedback
          setTimeout(() => onSelect(newTypes), 300);
        }
      }
    }
  };

  return (
    <div className="flex flex-col items-center gap-2 xs:gap-4 p-2 xs:p-4 bg-black/60 backdrop-blur-md rounded-lg border border-white/10  w-full max-h-[90vh]">
      <div className="text-center">
        <h2 className="text-xl   font-black italic text-white uppercase tracking-tight">
          SELECT 2 AFFINITIES
        </h2>
        <p className="text-pk-gray-3 text-[9px] font-bold mt-2 uppercase tracking-widest opacity-60">
          This determines your first partners ({selectedTypes.length}/2)
        </p>
      </div>

      <div className="overflow-y-hidden w-full grid grid-cols-2 xs:grid-cols-3 sm:grid-cols-4 gap-4 overflow-y-auto px-4 custom-scrollbar">
        {POKEMON_TYPES.map((type) => {
          const isSelected = selectedTypes.includes(type.name.toLowerCase());
          return (
            <button
              key={type.name}
              className={`
              group relative cursor-pointer flex flex-col items-center justify-center py-2 px-2 rounded-md transition-all active:scale-95
              hover:scale-105
              ${type.color}
              ${isSelected ? "ring-4 ring-white scale-105 z-10" : "opacity-80"}
            `}
              onClick={() => toggleType(type.name)}
            >
              {/* Glossy Overlay */}
              <div className="absolute inset-0 bg-gradient-to-b from-white/20 to-transparent rounded-xl opacity-50" />

              <span className="relative text-sm font-black text-white uppercase  drop-shadow-md">
                {type.name}
              </span>
            </button>
          );
        })}
      </div>

      <style
        dangerouslySetInnerHTML={{
          __html: `
        .custom-scrollbar::-webkit-scrollbar {
          width: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.2);
        }
      `,
        }}
      />
    </div>
  );
};
